import { RootState } from '../../store';
import { getAuthToken } from './auth';

export const prepareAuthHeaders = async (headers: Headers, { getState }: { getState: () => unknown }) => {
  const adminShellState = (getState() as RootState).adminShell;
  const token = await getAuthToken(adminShellState?.getAccessToken);
  if (token) {
    headers.set('Authorization', `Bearer ${token}`);
  }
  return headers;
};
